import { Campaign } from '../App';
import campaignData from '../data/campaign-data.json';
import sablierCampaignsData from '../data/sablier.json';
import { SablierCampaign } from './sablierTypes';

export interface CampaignDataStructure {
  ongoingCampaigns: Campaign[];
  previousCampaigns: Campaign[];
}

export const getCampaignData = (): CampaignDataStructure => {
  return campaignData as CampaignDataStructure;
};

export const getOngoingCampaigns = (): Campaign[] => {
  return getCampaignData().ongoingCampaigns;
};

export const getPreviousCampaigns = (): Campaign[] => {
  return getCampaignData().previousCampaigns;
};

/**
 * Get Sablier campaigns from sablier.json
 * @returns Array of Sablier campaigns
 */
export const getSablierCampaigns = (): SablierCampaign[] => {
  return sablierCampaignsData as SablierCampaign[];
};